import { render, staticRenderFns } from "./QuestionCategory.vue?vue&type=template&id=b3eef9c2&scoped=true"
import script from "./QuestionCategory.vue?vue&type=script&lang=js"
export * from "./QuestionCategory.vue?vue&type=script&lang=js"
import style0 from "./QuestionCategory.vue?vue&type=style&index=0&id=b3eef9c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3eef9c2",
  null
  
)

export default component.exports